<template>
	<div class="selectExcuteHuman">
		<el-tooltip class="item" effect="light" :disabled="(ExcuteName ? false : true)" :content="ExcuteName"  placement="top" :style="{width: setWidth}">
			<el-autocomplete
      			class="inline-input"
				:size="size"
				:style="{width: setWidth}"
      			v-model="ExcuteName"
				clearable
				@clear="reset"
      			:readonly="inputDis"
      			:fetch-suggestions="querySearch"
      			:placeholder="ExcuteHumanTitle"
				@change="changeExcuteName"
				@select="handleSelect"
				@blur="ExcuteBlur"
      			:trigger-on-focus="false">
      			<!-- <el-button slot="append" icon="el-icon-close" @click="reset"></el-button> -->
				<!-- <el-button :disabled="inputDis" slot="append" icon="el-icon-plus" @click="alertDialog"></el-button> -->
      		</el-autocomplete>
		</el-tooltip>
		<el-dialog :title="ExcuteHumanTitle" :visible.sync="dialogVisible" width="800px"  append-to-body :before-close="handleClose" :show-close="false">
			<el-input v-model="search" placeholder="输入姓名/电话/工号快速查找"></el-input>
			<el-table ref="selectFuncRoomTable" highlight-current-row :data="tables" tooltip-effect="dark" style="width: 100%" @row-click="rowClick"  @row-dblclick="toSure" v-scrollBar:tableArg height="280px" v-loading="loading">
				<el-table-column label="姓名" width="150">
					<template slot-scope="scope">{{ scope.row.NAME }}</template>
				</el-table-column>
				<el-table-column label="联系电话" width="150" >
					<template slot-scope="scope">{{ scope.row.TELEPHONE }}</template>
				</el-table-column>
				<el-table-column label="所在组织" show-overflow-tooltip width="200">
					<template slot-scope="scope">{{ scope.row.DEPTNAME }}</template>
				</el-table-column>
				<el-table-column label="工号" show-overflow-tooltip width="150">
					<template slot-scope="scope">{{ scope.row.CODE }}</template>
				</el-table-column>
				<el-table-column label="状态" show-overflow-tooltip width="100">
					<template slot-scope="scope">{{ scope.row.ONLINE == 1 ? '在线' : '离线' }}</template>
				</el-table-column>
			</el-table>
			<div style="text-align: center;margin-top: 20px;">
				<el-button @click="toClose">关闭</el-button>
				<el-button type="primary" @click="toSure">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { GetExcuteHumanList } from '@/api/modules/basicData/task'
	export default {
		name: 'selectExcuteHuman',
		data() {
			return {
				dialogVisible: false,
				ExcuteDataStay: null,
				ExcuteData: null,
				ExcuteNameStay: '',
				ExcuteName: '',
				loading: false,
				search: '',
				tableData: [],
				allLinkData: [],
        		userName:'',
				inputDis: false,
        		
			}
		},
		watch: {
			inputDisable(newValue) {
				this.inputDis = newValue;
			}
		},
		props: {
			setWidth: {
				type: String,
				default: ''
			},
			ExcuteHumanTitle:{
				type: String,
				default: '选择接收人'
			},
			inputDisable:{
				type: Boolean,
				default: false
			},
			size:{
				type: String,
				default: ''
			}
		},
		created(){
			if(!this.ServerCenterIds.length){
				this.$store.dispatch("changeServerCenterIds");
			}
		},
		mounted(){
			setTimeout(()=>{
				console.log('服务台',this.ServerCenterIds);
				GetExcuteHumanList(this.ServerCenterIds,"").then(res => {
					console.log('执行人',res);
					this.allLinkData = res;
					this.tableData = res;
				})
			},1000)
		},
		computed: {
			...mapState({
				ServerCenterIds: state=> state.task.ServerCenterIds,
			}),
			tables() {
				const search = this.search
				if(search) {
					return this.allLinkData.filter(dataNews => {
						var NAME = dataNews.NAME ? dataNews.NAME : "";
						var TELEPHONE = dataNews.TELEPHONE ? dataNews.TELEPHONE : "";
						var CODE = dataNews.CODE ? dataNews.CODE : "";
						return ((NAME.indexOf(search) > -1) || TELEPHONE.indexOf(search) > -1 || CODE.indexOf(search) > -1)
					})
				}
				return this.tableData
			}
		},
		methods: {
			changeExcuteName(value){
				this.ExcuteData = null; // 自己修改了功能间名称
			},
			alertDialog() { // 弹出主窗体
				this.dialogVisible = true;
				this.loading = true;
				if(this.allLinkData.length > 0){
					this.loading = false;
				}else{
					GetExcuteHumanList(this.ServerCenterIds,"").then(res => {
						this.allLinkData = res;
						this.tableData = res;
						this.loading = false;
					})
				}
				if(this.$refs.selectFuncRoomTable && !this.ExcuteData){
					this.$refs.selectFuncRoomTable.setCurrentRow();
				}
				this.ExcuteDataStay = null;
				this.ExcuteNameStay = '';
			},
			rowClick(row){
				this.ExcuteDataStay= row;
				this.ExcuteNameStay = row.NAME + (row.TELEPHONE ? (" " + row.TELEPHONE) : "")
			},
    		querySearch(queryString, cb) {//提示搜索
				var result = [];
    			var searchRes = this.allLinkData.filter((dataNews)=>{
					var NAME = dataNews.NAME ? dataNews.NAME : "";
					var TELEPHONE = dataNews.TELEPHONE ? dataNews.TELEPHONE : "";
					var CODE = dataNews.CODE ? dataNews.CODE : "";
					return ((NAME.indexOf(queryString) > -1) || TELEPHONE.indexOf(queryString) > -1 || CODE.indexOf(queryString) > -1)
				})
				searchRes.forEach((c) => {
					var NAME = c.NAME ? c.NAME : "";
					var TELEPHONE = c.TELEPHONE ? (" "+c.TELEPHONE) : "";
					c.value = NAME + TELEPHONE
					result.push(c)
				})
        		cb(result)
      		},
			ExcuteBlur(){
				if(!this.ExcuteData || this.ExcuteData.value != this.ExcuteName){
					this.ExcuteName = ''
				}
			},
			handleSelect(item) {
				this.ExcuteName = item.value;
				this.ExcuteData = item;
				this.$emit("getValue", item)
			},
     		reset(){//叉叉
				this.ExcuteData = null;
				this.ExcuteName = '';
				this.$emit("getValue", null)
			},
			handleClose(done){//弹出框消失前执行
			},
			toClose(){//取消
				this.dialogVisible = false
			},
			toSure(){//确定
				if(this.ExcuteNameStay && this.ExcuteDataStay){
					this.ExcuteName = this.ExcuteNameStay;
					this.ExcuteData = this.ExcuteDataStay;
					this.$emit("getValue", this.ExcuteData)
					this.dialogVisible = false;
				}else{
					this.$message.error('请先选中一个接收人!');
				}
			},
		}
	}
</script>

<style scoped>
	.selectExcuteHuman .el-button{
		padding: 12px;
	}
</style>